// extracted by mini-css-extract-plugin
export default {"button":"edit_forgotten_password_page-module___button___f7975d34","marginBottom":"edit_forgotten_password_page-module___marginBottom___e2780156"};